<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>There were two members of my family who unconditionally supported me during the writing of this book. Their complete attentiveness and devotion never wavered, and I would like to say how grateful I was for their efforts to keep me warm in the conservatory during the long winter evenings.</p>
<p>Lying across my feet really did work!</p>
<p>Max and Teddy, thank you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?2bb65a83